<template>
  <svg class="spinner" :style="{ width: `${width}px`, height: `${height}px`, marginTop: -height / 2, marginLeft: -width / 2 }" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
  </svg>
</template>

<script lang="ts" setup>
interface IProps {
  width?: number
  height?: number
}

withDefaults(defineProps<IProps>(), {
  width: 50,
  height: 50,
})
</script>

<style scoped lang="scss">
.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;

  & .path {
    stroke: #26a2f8;
    stroke-linecap: square;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
